import { render, staticRenderFns } from "./CustomerParticipantDetails.vue?vue&type=template&id=ecf45958&scoped=true&"
import script from "./CustomerParticipantDetails.vue?vue&type=script&lang=ts&"
export * from "./CustomerParticipantDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerParticipantDetails.vue?vue&type=style&index=0&id=ecf45958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf45958",
  null
  
)

export default component.exports